(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-worn-by"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.as-worn-by__btn[data-direction]');
    if (!button) return;
    const track = button.closest('.as-worn-by').querySelector('.as-worn-by__track');
    const item = track && track.querySelector('.as-worn-by__item');
    if (!item) return;
    const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    const distance = (item.getBoundingClientRect().width + gap) * 2;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    track.scrollBy({ left: Number(button.dataset.direction) * distance, behavior });
  });

  } catch(e) { console.error(e); }
})();
})();
